import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ConfigProvider } from "antd";
import AppRoutes from "./routes";
import { store, persistor } from "./store";

const AppWithNotificationIdentity = () => {
  const user = useSelector((state) => state.userProfile.user);

  useEffect(() => {
    if (user?.email) {
      window.appilix_push_notification_user_identity = user.email;
    }
  }, [user?.email]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const rfc = urlParams.get("konnectrfc") || urlParams.get("ref");
    if (rfc) {
      localStorage.setItem("signup_referral_code", rfc);
    }

    const stateParam = urlParams.get("state");
    const lgaParam = urlParams.get("lga");
    if (stateParam && lgaParam) {
      localStorage.setItem(
        "selectedLocation",
        JSON.stringify({ state: stateParam, lga: lgaParam }),
      );
    }
  }, []);

  return <AppRoutes />;
};

const App = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          // colorPrimary: "#000000",
        },
      }}
    >
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AppWithNotificationIdentity />
          </PersistGate>
        </Provider>
      </GoogleOAuthProvider>
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.querySelector("#root"));

if ("serviceWorker" in navigator && (window.location.protocol === "https:" || window.location.hostname === "localhost")) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/service-worker.js").catch(() => {}));
}

root.render(<App />);
